import '../../styles/style.css'

const FieldStats = () => {
  return (
    // Just resuse styles from other billboard component
    <div className="phoniciContent">
        <h1 className="heading1">Field Stats</h1>
        <h2 className="heading2">Sport's Information and Analytics Page</h2>
        <p className="descriptionText">Full Stack React Application using <span className="highlight-text">TypeScript, PostgreSQL, CSS, and Express</span>. <br></br>Much more to come!</p>

        <div className="social-icons">
            <a target='_blank' href='https://fieldstats.up.railway.app'><img className='fieldStatsIcon' src='./logo_favicon_blue.webp'></img></a>
            <a target="_blank" href="https://www.linkedin.com/in/derisomalley/details/projects/"><i className='bx bxl-linkedin'></i></a>
            <a target="_blank" href="https://github.com/DerisO22/FieldStats"><i className='bx bxl-github'></i></a>
        </div>
        
        {/* <!-- Example Images --> */}
        <h2 className="app_examples_header">From The Project</h2>

        <div className="imageExampleContainerHCI">
            <div className="image1_container">
                <img className="example_image1" src="/fieldstats_assets/homePage.webp" alt="Field Stats Home Page"></img>
                <div className="phonici_example1_overlay">
                    <div className="overlay_text">Landing Home Page</div>
                </div>
            </div>
            <div className="image2_container">
                <img className="example_image2" src="/fieldstats_assets/allSports.webp" alt="Sports Page"></img>
                <div className="phonici_example2_overlay">
                    <div className="overlay_text">Sports Page Displaying Different Sports</div>
                </div>
            </div>
            <div className="image2_container">
                <img className="example_image1" src="/fieldstats_assets/sportPage.webp" alt="Sport Details Page"></img>
                <div className="phonici_example2_overlay">
                    <div className="overlay_text">Sport Details Page Outlining a certain Sport</div>
                </div>
            </div>
            <div className="image2_container">
                <img className="example_image1" src="/fieldstats_assets/playerStats.webp" alt="Hard C"></img>
                <div className="phonici_example2_overlay">
                    <div className="overlay_text">Individual Player Profile Pages Displaying Their Stats (Dark Mode)</div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default FieldStats;